/**
 * Renders a dropdown menu
 * @property {array} options - Array of objects used to populate the dropdown options
 * @property {string} triggerText - The text for the dropdown trigger
 */

import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { isDescendant } from '../../helpers/helpers';

const SmarterDropdown = observer(class SmarterDropdown extends React.Component {
  constructor() {
    super();

    // Set the initial state
    this.state = {
      active: false
    };

    this.items = [];
    this.firstItem = null;
    this.lastItem = null;
  }

  componentDidMount() {
    // Hide when anything else is clicked
    document.addEventListener('click', (e) => {
      if(this.state.active && !isDescendant(this.dropdown, e.target)) {
        this.setState({
          active: false
        });
      }
    });
    this.items = this.content.querySelectorAll('a.dropdown__item');
    this.firstItem = this.items[0];
    this.lastItem = this.items[this.items.length - 1];
  }

  hide() {
    const { studentDropdownState } = this.props;

    if (studentDropdownState) {
      studentDropdownState();
    }

    this.setState({
      active: false
    }, ()=> {
      this.trigger.focus();
    })
  }

  show() {
    this.setState({
      active: true
    }, () => {
      this.firstItem.focus();
    })
  }

  showLast() {
    this.setState({
      active: true
    }, () => {
      this.lastItem.focus();
    })
  }

  escape() {
    if (this.state.active) {
      this.hide();
      this.trigger.focus();
    }
  }

  toggleDropdown = () => {
    if (this.state.active) {
      this.hide();
    } else {
      this.show();
    }
  }

  setFocusToPreviousItem = (e) => {
    if (e.target === this.firstItem) {
      this.lastItem.focus();
    }
    else {
      var index = Array.prototype.indexOf.call(this.items, e.target);
      this.items[index - 1].focus();
    }
  }

  setFocusToNextItem = (e) => {
    if (e.target === this.lastItem) {
      this.firstItem.focus();
    }
    else {
      var index = Array.prototype.indexOf.call(this.items, e.target);
      this.items[index + 1].focus();
    }
  }

  handleButtonKeyDown = (e) => {
    const DOWN_ARROW = 40;
    const UP_ARROW = 38;

    switch(e.keyCode) {
      case DOWN_ARROW:
        e.preventDefault();
        if (!this.state.active) {
          this.show();
        } else {
          this.firstItem.focus();
        }
        break;
      case UP_ARROW:
        e.preventDefault();
        if (!this.state.active) {
          this.showLast();
        } else {
          this.lastItem.focus();
        }
        break;
      default:
    }
  }

  handleContentKeyDown = (e) => {
    const DOWN_ARROW = 40;
    const UP_ARROW = 38;

    switch(e.keyCode) {
      case DOWN_ARROW:
        e.preventDefault();
        this.setFocusToNextItem(e);
        break;
      case UP_ARROW:
        e.preventDefault();
        this.setFocusToPreviousItem(e);
        break;
      default:
    }
  }

  handleCommonKeyDown = (e) => {
    const ESCAPE = 27;
    const END = 35;
    const HOME = 36;
    const TAB = 9;

    switch(e.keyCode) {
      case ESCAPE:
        this.escape();
        break;
      case HOME:
        if (this.state.active) {
          e.preventDefault();
          this.firstItem.focus();
        }
        break;
      case END:
        if (this.state.active) {
          e.preventDefault();
          this.lastItem.focus();
        }
        break;
      case TAB:
        e.preventDefault();
        if (this.state.active) {
          this.hide();
        }
        this.trigger.focus(); 
        break;
      default:
        break;
    }
  }

  render() {
    const {
      id,
      triggerText
    } = this.props;

    return (
      <div
        id={`${id}-dropdown`}
        className={`dropdown ${this.state.active ? "dropdown--active" : "dropdown--closed"}`}
        ref={(div) => this.dropdown = div}
        onKeyDown={this.handleCommonKeyDown}
      >
        <button
          id={`${id}-trigger`}
          className="navbar__item dropdown__trigger" 
          tabIndex="0" 
          type="button"
          aria-controls={`${id}-content`} 
          aria-haspopup="true"
          aria-expanded={this.state.active ? true : false}
          onClick={this.toggleDropdown}
          onKeyDown={this.handleButtonKeyDown}
          ref={(button) => this.trigger = button}
        >

          {triggerText}

        </button>

        <ul
          id={`${id}-content`}
          role="menu"
          className="dropdown__menu"
          hidden={this.state.active ? false : true}
          aria-hidden={this.state.active ? false : true}
          ref={(ul) => this.content = ul}
          onKeyDown={this.handleContentKeyDown}
        >
          {this.props.children}
        </ul>
      </div>
    );
  }
})

export default observer(SmarterDropdown);


// WEBPACK FOOTER //
// ./src/app/components/Common/SmarterDropdown.js